import { makeStyles, tokens } from '@fluentui/react-components';
import { IoClose } from 'react-icons/io5';

interface Props {
  onClick: () => void;
}

export default function ClearebleButtonInput(props: Props) {
	const classes = clearebleButtonInputStyles();

	return (
		<button className={classes.clearIcon} onClick={props.onClick}>
			<IoClose size={20} />
		</button>
	);
}

export const clearebleButtonInputStyles = makeStyles({
	clearIcon: {
		backgroundColor: 'transparent',
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		color: tokens.colorNeutralForeground2,
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase100,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase100,
		height: '100%',
		width: '100%',
		position: 'relative',
		right: '-2px',
		minWidth: '0px',
		padding: '2px 0px',
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
		},
		':active': {
			background: tokens.colorNeutralBackground4Hover,
		}
	}
});